import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Input, InputGroup, InputGroupAddon, Row } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import styles from '../form.module.scss';

class YearFilter extends Component {
  static contextTypes = {
    theme: PropTypes.object
  };

  render() {
    const BS = this.context.theme;
    const { minYear, maxYear, tabIndex } = this.props;

    return (
      <Row>
        <Col xs={6}>
          <InputGroup>
            <InputGroupAddon
              tag="label"
              htmlFor="minYear"
              addonType="prepend"
              className={styles.inlineInputGroupAddon}
            >
              <FontAwesome name="calendar" className={BS.inputGroupText} />
            </InputGroupAddon>
            <Input
              {...minYear.input}
              placeholder="No Min"
              tabIndex={tabIndex}
              onChange={e => {
                const val = e.target.value;
                minYear.input.onChange(val !== '' ? parseInt(val, 0) : val);
              }}
            />
          </InputGroup>
        </Col>
        <Col xs={6} className={BS.colDivider}>
          <InputGroup>
            <InputGroupAddon
              tag="label"
              htmlFor="maxYear"
              addonType="prepend"
              className={styles.inlineInputGroupAddon}
            >
              <FontAwesome name="calendar" className={BS.inputGroupText} />
            </InputGroupAddon>
            <Input
              {...maxYear.input}
              placeholder="No Max"
              tabIndex={tabIndex ? tabIndex + 1 : tabIndex}
              onChange={e => {
                const val = e.target.value;
                maxYear.input.onChange(val !== '' ? parseInt(val, 0) : val);
              }}
            />
          </InputGroup>
        </Col>
      </Row>
    );
  }
}

export default YearFilter;



// WEBPACK FOOTER //
// ./src/components/form/filter/year-filter.js